import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'mc-drawer-back-link',
  templateUrl: './drawer-back-link.component.html',
  styleUrls: ['./drawer-back-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawerBackLinkComponent {
  @Input() link: string;
}
